/* jshint esversion: 9 */
import RepositoryEntry from './RepositoryEntry';

/**
 * Represents a ContentObject class that manages various aspects of content entries.
 */
class ContentObject extends RepositoryEntry {
    /**
     * Constructs a new ContentObject instance.
     * @param {Object} entry - The entry object containing content details.
     * @param {Object} $injector - The injector object for dependency injection.
     */
    constructor(entry, $injector) {
        super(entry, $injector);

        // Define readable properties
        this.readables({
            'type': String
        });

        // Define accessible properties
        this.accessables({
            'objectType': String,
            'content': Object,
            'preferences': Object,
            'attachement': Object
        });

        // Define references
        this.references({
            'contentReference': '*'
        });

        // Convert object type to camel case
        let camelCaseType = this.getObjectType().charAt(0).toUpperCase() + this.getObjectType().slice(1);
        camelCaseType = camelCaseType.replace(/-([a-z])/g, function (g) {
            return g[1].toUpperCase();
        });

        // Define validators
        const vals = {
            'HintEmptyObjectNameValidator': 'HintEmptyObjectNameValidator',
            'HintEmptySelectLevelValidator': 'HintEmptySelectLevelValidator',
            'HintSelectLevelValidator': 'HintSelectLevelValidator',
            'HintEmptyContentValidator': 'HintEmptyContentValidator',
            'QPResponsePDFValidator': 'QPResponsePDFValidator',
            'EmptyValidator': camelCaseType + 'EmptyValidator',
            'ResponsePDFValidator': camelCaseType + 'ResponsePDFValidator',
            'AutoplotTargetValidator': 'AutoplotTargetValidator'
        };

        // Add specific validator for textMCQ type
        if (this.getObjectType() === 'textMCQ') {
            vals['TextMCQMaxLengthValidator'] = 'TextMCQMaxLengthValidator';
        }

        this.validators(vals);

        this.$signals = $injector.get('$signals');

    }

    /**
     * Retrieves the TaskDataService instance.
     * @returns {Object} The TaskDataService instance.
     */
    getTaskDataService() {
        if (!this._TaskDataService) {
            this._TaskDataService = this.$injector.get('TaskDataService');
        }
        return this._TaskDataService;
    }

    /**
     * Fetches the context using the TaskDataService.
     * @returns {Object} The fetched context.
     */
    fetchContext() {
        if (!this._fetchContext) {
            this._fetchContext = this.getTaskDataService().fetchContext();
        }
        return this._fetchContext;
    }

    /**
     * Checks if the content is empty.
     * @returns {boolean} True if the content is empty, false otherwise.
     */
    isContentEmpty() {
        const c = this.getContent();
        // Last check is for Wiris objects

        switch (this.getObjectType()) {
            case 'image':
            case 'geogebra':
            case 'audio':
            case 'video':
            case 'iframe':
                if (this.fetchContext().exists(this.data.contentReference)) {
                    return !this.getContentReference();
                }
                return false;
            default:
                return typeof (c) === 'undefined' || c == null || c.trim() === '' || c.length === 0 || c == '<math xmlns="http://www.w3.org/1998/Math/MathML"/>';
        }
    }

    /**
     * Sets a preference value.
     * @param {string} key - The preference key.
     * @param {*} value - The preference value.
     * @returns {ContentObject} The current instance for chaining.
     */
    setPreference(key, value) {
        const tmp = { ...this.getPreferences() };
        tmp[key] = value;
        this.setPreferences(tmp);

        return this;
    }

    /**
     * Gets a preference value.
     * @param {string} key - The preference key.
     * @returns {*} The preference value or undefined if not found.
     */
    getPreference(key) {
        const tmp = this.getPreferences();

        return tmp[key] || undefined;
    }

    /**
     * Performs actions before saving the content.
     */
    onBeforeSave() {
        const attachment = this.getAttachement();
        const obsoleteKeys = [];
        let key;

        if (!angular.isDefined(attachment)) {
            return;
        }

        for (key in attachment) {
            if (typeof attachment[key] == 'undefined' || attachment[key] == '') {
                obsoleteKeys.push(key);
            }
        }

        for (let i = 0; i < obsoleteKeys.length; i++) {
            key = obsoleteKeys[i];
            delete attachment[key];
        }
    }

    /*
    getObjectType() {
        return this.objectType;
    }

    getContent() {
        return this.content;
    }

    getPreferences() {
        return this.preferences;
    }

    setPreferences(preferences) {
        this.preferences = preferences;
    }

    getAttachment() {
        return this.attachment;
    }

    getContentReference() {
        return this.contentReference;
    }
        */
}

export default ContentObject;